<template>
    <div class="match-details__stats-container" 
        v-show="!isShowNoData">
        <div class="match-detail__stats-wrapper" >
            <div class="match-detail__stats-header form-guide-title">
                {{ $t("FORM_GUIDE") }}
            </div>
    
            <div class="form-guide-list">
                <div class="form-guide-item">
                    <div class="form-guide-flex-container">
                        <div class="form-guide-flex-container-box form-guide-header-box">
                            <div class="form-guide-header">
                                <Icon
                                    :logoUrl="matchDetailScore.homeLogo"
                                    hasClass="form-guide-logo-icon"
                                ></Icon>
                                <!-- <div class="form-guide-header-title">
                                    {{matchDetailScore.homeTeamName}}
                                </div> -->
                            </div>
                        </div>
                        <div class="form-guide-flex-container-box form-guide-header-box right">
                            <div class="form-guide-header">
                                <Icon
                                    :logoUrl="matchDetailScore.awayLogo"
                                    hasClass="form-guide-logo-icon"
                                ></Icon>
                                <!-- <div class="form-guide-header-title">
                                    {{matchDetailScore.awayTeamName}}
                                </div> -->
                            </div>
                        </div>
                    </div>
    
                    <div class="form-guide-child-list" v-if="!isShowNoData">
                        <div v-if="matchLength(formGuide.homeTeam.matches, formGuide.awayTeam.matches) !== 0">
                            <div v-for="(i,index) in matchLength(formGuide.homeTeam.matches, formGuide.awayTeam.matches)">
                                <FormGuideCard 
                                    :homeTeam="formGuide.homeTeam.matches[index]"
                                    :awayTeam="formGuide.awayTeam.matches[index]"
                                    :matchDetailScore="matchDetailScore"  />
                            </div>
                        </div>
                        <NoData v-else />

                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex';
    import FormGuideCard from "./FormGuideCard.vue"

    export default {
        name: 'FormGuide',
        data() {
            return {
                
                isShowNoData: true,
                isLoading: false,
                matchId: '',
                formGuide: {}
            }
        },
        props: ["matchDetailScore"],
        components: {
            FormGuideCard
        },
        computed: {
        },
        created() {
            this.matchId = this.$route.params.matchId;
        },
        mounted() {
            this.getFormGuideData()
            // this.isShowNoData = false;
        },
        methods: {
            ...mapActions(['getMatchDetailFormGuide']),
            async getFormGuideData() {
                const result = await this.getMatchDetailFormGuide({
                    matchId: this.matchId
                })
                if(result.errorCode === 0) {
                    this.isShowNoData = false
                    this.formGuide = result.result
                }
            },
            otherTeamName(i, fatherTeamName) {
                if(i.homeTeamName !== fatherTeamName) {
                    return i.homeTeamName
                } else if(i.awayTeamName !== fatherTeamName) {
                    return i.awayTeamName
                }
            },
            matchLength(homeTeamMatches, awayTeamMatches) {
                return Math.max(homeTeamMatches.length, awayTeamMatches.length);
            }
        }
    }
</script>


<style scoped>

.match-detail__stats-wrapper {
  margin: 0 auto;
}
.match-detail__stats-header {
  padding: 0 0 1.5rem 0;
  /* margin: 0 1rem; */
  text-align: left;
  font-family: var(--weight-700);
  text-align: center;
  font-size: var(--typography-body-size-large);
  margin-top: 24px;
  letter-spacing: 0.64px;
  /* padding-top: 24px; */
}
.form-guide-list {
    display: flex;
    justify-content: center;
    gap: 168px;
    padding-bottom: 8px;
    margin-bottom: 8px;
}
.form-guide-item {

}
.form-guide-flex-container {
    display: flex;
    justify-content: center;
    gap: 240px;
    display: none;
}
.form-guide-flex-container-box {
    width: 100%;
    display: flex;
    gap: 294px;
    flex-shrink: 0;
    justify-content: center;
}
.form-guide-child-box {
    width: 50%;
}
/* .form-guide-child-box.left .form-guide-child-item {
    padding-right: 100px;
}
.form-guide-child-box.right .form-guide-child-item {
    padding-left: 100px;
} */
.form-guide-header-box {
    padding-left: 92px;
}
.form-guide-header-box.right {
    padding-left: 0;
    padding-right: 92px;
}
.form-guide-header-box,
.form-guide-header-box .form-guide-flex-container-box {
    width: 50%;
    flex: 1;
    /* min-width: 98px; */
}
.form-guide-header {
    text-align: center;
    
}
.form-guide-logo-icon {
    height: 66.67px;
    width: 66.67px;
    margin: auto;
    display: block;
}
.form-guide-header-title {
    font-size: 20px;
    font-family: var(--weight-600);
    margin-top: 4px;
}
.form-guide-child-list {
    /* margin-top: 16px; */
}
.form-guide-child-item {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px dashed var(--gray-300);
    display: flex;
    justify-content: right;
}
.form-guide-child-item.right {
    justify-content: left;
}
.form-guide-child-item-box {
    /* width: 98px; */
}
.form-guide-child-item:last-child {
    
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: 0;
}
.form-guide-item {
    width: 100%;
}
.form-guide-child-result {
    display: flex;
    align-items: center;
    justify-content: right;
    position: relative;

}
.form-guide-child-result.right {
    justify-content: left;
}
.form-guide-child-box.right .form-guide-child-name {
    text-align: left;
}
.form-guide-child-logo-icon {
    width: 33.33px;
    height: 33.33px;
    display: inherit;
}
.form-guide-child-result-score {
    font-size: 24px;
    font-family: var(--weight-600);
    padding: 0 16px;
    position: relative;
	letter-spacing: -0.64px;
}
.form-guide-child-result-winlose {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-family: var(--weight-700);
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--white-1000);
	letter-spacing: 0.2px;
}
.winlose-0 {
    background-color: var(--success-500);
}
.winlose-1 {
    background-color: var(--error-500);
}
.winlose-2 {
    background-color: var(--gray-500);
}
.winlose-left {
    left: -32px;
}
.winlose-right {
    right: -32px;
}
/* .form-guide-flex-container-box:nth-child(odd) .winlose-left {
    display: none;
}
.form-guide-flex-container-box:nth-child(even) .winlose-right {
    display: none;
} */
.form-guide-child-name {
    font-size: 13px;
    font-weight: 500;
    padding-top: 3px;
    text-align: center;
}
.form-guide-title {
    margin-top: calc(24px);
    font-size: 32px;
	line-height: 120%;
	letter-spacing: -0.64px;
    font-family: var(--weight-600);
}
.match-details__stats-container {
  /* margin-bottom: 36px; */
}
@media(max-width: 768px) {  /* for test */
.match-details__stats-container {
    background-color: var(--color-background-default-secondary);
  border-radius: 8px;
  margin-top: 0;
  padding: 16px;
  margin-bottom: 0;
}

.match-detail__stats-header {
  margin-top: 0;
  font-size: 24px;
  padding-top: 0;
  letter-spacing: -0.64px;
  font-family: var(--weight-600);
}
.form-guide-flex-container {
    display: flex;
    justify-content: center;
    gap: 0;
    display: none;
}
.form-guide-flex-container-box {
    gap: 23px;
}
.form-guide-child-list > div > div:last-child .form-guide-flex-container-box {
    border-bottom: 0;
}
.form-guide-header-box {
    padding-left: 0;
}
.form-guide-header-box.right {
    padding-right: 0;
}
.form-guide-logo-icon {
    width: 35.75px;
    height: 35.75px;
}
.form-guide-header-title {
    font-size: 13px;
    word-break: break-all;
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;

}

}
</style>